const generateAlphabet = (arrLen = 26): string[] => {
  const alpha = Array.from(Array(arrLen)).map((e, i) => i + 65);
  return alpha.map((x) => String.fromCharCode(x));
};

export default generateAlphabet;
